import {
  ADD_TO_CART,
  DELETE_CART,
  INCREASE_ITEM_QUANTITY,
  DECREASE_ITEM_QUANTITY,
  CLEAR_CART,
  GET_CHECKOUT_QUESTIONS,
} from "../types";

const initialState = {
  cartItems: [],
  checkoutQuestions: [],
  tipDetails: null,
  cartDetails: null,
  tableDetails: null,
  addressDetails: null,
  extendLoading: false,
  endLoading: false,
  orderType: null,
  addOnsDetail: [],
  allTablesData: {},
};
let cart = [];
export default function cartReducer(
  state = initialState,
  { type, payload, action }
) {
  switch (type) {
    case ADD_TO_CART: {
      const newItem = {
        ...payload,
        totalPrice: Math.floor(payload.totalPrice),
      };

      const currentCartState = state.cartItems || [];

      const sameRestaurantItems = currentCartState.filter(
        (item) => item.restaurantID === payload.restaurantID
      );

      let existingItemIndex;

      if (payload.type === "offer") {
        existingItemIndex = sameRestaurantItems.findIndex(
          (item) => item.type === "offer" && item.id === payload.id
        );
      } else {
        existingItemIndex = sameRestaurantItems.findIndex(
          (item) => item.id === payload.id && item.size === payload.size
        );
      }

      if (existingItemIndex !== -1) {
        const existingItem = sameRestaurantItems[existingItemIndex];

        const mergedAddonsMap = new Map();
        existingItem.addons?.forEach((addon) => {
          mergedAddonsMap.set(addon.id, { ...addon });
        });

        payload.addons?.forEach((addon) => {
          if (mergedAddonsMap.has(addon.id)) {
            const existingAddon = mergedAddonsMap.get(addon.id);
            mergedAddonsMap.set(addon.id, {
              ...existingAddon,
              quantity: existingAddon.quantity + addon.quantity,
            });
          } else {
            mergedAddonsMap.set(addon.id, { ...addon });
          }
        });

        const mergedAddons = Array.from(mergedAddonsMap.values());

        const updatedItem = {
          ...existingItem,
          notes: payload.notes,
          quantity: existingItem.quantity + payload.quantity,
          totalPrice:
            existingItem.totalPrice + payload.price * payload.quantity,
          addons: mergedAddons,
        };

        const updatedCartItems = [...sameRestaurantItems];
        updatedCartItems[existingItemIndex] = updatedItem;

        return {
          ...state,
          cartItems: updatedCartItems,
        };
      }
      return {
        ...state,
        cartItems: [...sameRestaurantItems, newItem],
      };
    }

    case "UPDATE_ADDONS": {
      const updatedItem = payload;

      const existingItemIndex = state.cartItems?.findIndex(
        (item) => item.id === updatedItem.id && item.size === updatedItem.size
      );

      if (existingItemIndex === -1) return state;

      const updatedCartItems = [...state.cartItems];
      updatedCartItems[existingItemIndex] = {
        ...updatedCartItems[existingItemIndex],
        addons: updatedItem.addons.filter((a) => a.quantity > 0),
        totalPrice:
          updatedCartItems[existingItemIndex].price *
            updatedCartItems[existingItemIndex].quantity +
          updatedItem.addons.reduce((sum, a) => sum + a.price * a.quantity, 0),
      };

      return {
        ...state,
        cartItems: updatedCartItems,
      };
    }

    case "FETCH_ALL_TABLES_SUCCESS":
      return {
        ...state,
        allTablesData: payload,
      };

    case "CART_DETAILS":
      return {
        ...state,
        cartDetails: payload,
      };

    case "END_LOADING":
      return {
        ...state,
        endLoading: {
          ...state.endLoading,
          [payload.tableId]: payload.loading,
        },
      };
    case "EXTEND_LOADING":
      return {
        ...state,
        extendLoading: {
          ...state.extendLoading,
          [payload.tableId]: payload.loading,
        },
      };

    case "CHANGE_ORDER_TYPE":
      return {
        ...state,
        orderType: payload,
      };
    case "FETCH_ADD_ONS":
      return {
        ...state,
        addOnsDetail: payload,
      };

    case INCREASE_ITEM_QUANTITY: {
      cart = [...state.cartItems];
      let itemIndex = -1;

      if (payload.type === "offer") {
        itemIndex = cart.findIndex(
          (val) => val.type === "offer" && val.id === payload.id
        );
      } else {
        itemIndex = cart.findIndex(
          (val) => val?.id === payload.id && val.size === payload.size
        );
      }

      if (itemIndex !== -1) {
        cart[itemIndex].quantity += 1;
        cart[itemIndex].totalPrice += cart[itemIndex].price;
      }

      return {
        ...state,
        cartItems: cart,
      };
    }

    case DECREASE_ITEM_QUANTITY: {
      cart = [...state.cartItems];
      let itemIndex = -1;

      if (payload.type === "offer") {
        itemIndex = cart.findIndex(
          (val) => val.type === "offer" && val.id === payload.id
        );
      } else {
        itemIndex = cart.findIndex(
          (val) => val?.id === payload.id && val.size === payload.size
        );
      }

      if (itemIndex !== -1 && cart[itemIndex].quantity > 0) {
        cart[itemIndex].quantity -= 1;
        cart[itemIndex].totalPrice -= cart[itemIndex].price;
      }

      return {
        ...state,
        cartItems: cart,
      };
    }

    case DELETE_CART:
      cart = [...state.cartItems];
      const cartDeleteIndex = cart?.findIndex(
        (val) =>
          val?.menuItemID === payload.menuItemID && val.size === payload.size
      );

      cart.splice(cartDeleteIndex, 1);
      return {
        ...state,
        cartItems: cart,
      };
    case CLEAR_CART:
      return {
        ...state,
        cartItems: [],
        tipDetails: null,
        tableDetails: null,
      };
    case "CLEAR_CART_DETAILS":
      return {
        ...state,
        cartDetails: null,
      };
    case GET_CHECKOUT_QUESTIONS: {
      return {
        ...state,
        checkoutQuestions: payload,
      };
    }
    case "TIP_DETAILS": {
      return {
        ...state,
        tipDetails: payload,
      };
    }
    case "TABLE_UPDATE": {
      return {
        ...state,
        tableDetails: payload,
      };
    }
    case "DELIVERY_UPDATE": {
      return {
        ...state,
        addressDetails: payload,
      };
    }
    default:
      return { ...state };
  }
}
